export const state = {
  // Reports by organization ID
  // Structure: { [orgId]: { [reportUuid]: report } }
  reports: {},

  // Current active report UUID
  activeReportUuid: null,

  // Current active version (null means latest)
  activeVersion: null
}
